// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-contact-js": function componentSrcPagesContactJs() {
    return import("./../../src/pages/contact.js"
    /* webpackChunkName: "component---src-pages-contact-js" */
    );
  },
  "component---src-pages-csswand-js": function componentSrcPagesCsswandJs() {
    return import("./../../src/pages/csswand.js"
    /* webpackChunkName: "component---src-pages-csswand-js" */
    );
  },
  "component---src-pages-design-js": function componentSrcPagesDesignJs() {
    return import("./../../src/pages/design.js"
    /* webpackChunkName: "component---src-pages-design-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-page-2-js": function componentSrcPagesPage2Js() {
    return import("./../../src/pages/page-2.js"
    /* webpackChunkName: "component---src-pages-page-2-js" */
    );
  },
  "component---src-pages-pinterest-clone-js": function componentSrcPagesPinterestCloneJs() {
    return import("./../../src/pages/pinterest-clone.js"
    /* webpackChunkName: "component---src-pages-pinterest-clone-js" */
    );
  },
  "component---src-pages-projects-js": function componentSrcPagesProjectsJs() {
    return import("./../../src/pages/projects.js"
    /* webpackChunkName: "component---src-pages-projects-js" */
    );
  },
  "component---src-pages-react-movie-js": function componentSrcPagesReactMovieJs() {
    return import("./../../src/pages/react-movie.js"
    /* webpackChunkName: "component---src-pages-react-movie-js" */
    );
  },
  "component---src-pages-react-weather-js": function componentSrcPagesReactWeatherJs() {
    return import("./../../src/pages/react-weather.js"
    /* webpackChunkName: "component---src-pages-react-weather-js" */
    );
  },
  "component---src-pages-resume-maker-js": function componentSrcPagesResumeMakerJs() {
    return import("./../../src/pages/resume-maker.js"
    /* webpackChunkName: "component---src-pages-resume-maker-js" */
    );
  },
  "component---src-pages-youtube-js": function componentSrcPagesYoutubeJs() {
    return import("./../../src/pages/youtube.js"
    /* webpackChunkName: "component---src-pages-youtube-js" */
    );
  }
};